import Chip from "@mui/material/Chip"
import { styled } from "@mui/material/styles"

import GlassMixin from "../../../common/components/GlassMixin"

export default styled(Chip)(({ theme }) => ({
  color: theme.palette.colors.gray500,
  fontWeight: 500,
  fontSize: "14px",

  padding: "8px",
  borderRadius: "16px",
  ...GlassMixin,
  "& .MuiSvgIcon-root": {
    fill: theme.palette.colors.gray500,
    width: "14px",
  },
  "&:hover": {
    cursor: "pointer",
    background:
      "linear-gradient(159deg, rgba(255, 255, 255, 0.5) 3.01%, rgba(255, 255, 255, 0.7) 103.3%)",
  },
  "&.active": {
    background:
      "linear-gradient(159deg, rgba(137, 47, 206, 1) 3%, rgba(137, 47, 206, 0.8) 100%)",
    backdropFilter: "blur(12px)",
    "& .MuiSvgIcon-root": {
      fill: "white",
    },
    "& .MuiChip-label": {
      color: "white",
    },
  },
}))
